import React, { useState } from "react";
import ModalBootstrap from 'react-bootstrap/Modal';
import CloseButton from '../../../common/CloseButton';
import moment from 'moment';
import { bannedWords } from '../../../utils/helper';
import currency from 'currency.js';
import { Spinner } from "react-bootstrap";
import AlertConfirmModal from "../../../common/AlertConfirmModal";
import { captureException } from "@sentry/browser";
import { s3Link } from "../../../utils/constants";
import copy from 'copy-to-clipboard';
import { useToasts } from 'react-toast-notifications';

export default function MassMessageStatsModal() {
    const { addToast } = useToasts();
    const [statsListModalIsOpen, setStatsListModalIsOpen] = useState(false);
    const [statsList, setStatsList] = useState([]);
    const [statsListCount, setStatsListCount] = useState(0);
    const [statsListLoading, setStatsListLoading] = useState(false);
    const [statsListReachedEnd, setStatsListReachedEnd] = useState(false);
    const [removedBroadcasts, setRemovedBroadcasts] = useState([]);
    const [expandBroadcasts, setExpandBroadcasts] = useState([]);
    const [statsListMedia, setStatsListMedia] = useState([]);
    const [statsListMediaModalIsOpen, setStatsListMediaModalIsOpen] = useState(false);

    const [showConfirm, setShowConfirm] = useState(false);
    const [activeBroadcastId, setActiveBroadcastId] = useState('');
    const handleConfirm = (broadcastId) => {
        setShowConfirm(true);
        setActiveBroadcastId(broadcastId);
    };

    const renderTypeLabel = (broadcast) => {
        switch (broadcast.type) {
            case 0:
                return 'All Subscribers';
            case 1:
                return 'New Subscribers';
            case 2:
                return 'Subscriber Range';
            case 3:
                return 'Unsubscribed';
            case 4:
                return 'Favourites';
            case 5:
                return 'Re-send';
            case 6:
                return 'Online';
            case 7:
                return 'User Lists';
            default:
                return '';
        }
    };

    const renderTypeDataLabel = (broadcast) => {
        if ([0, 2, 5].includes(broadcast.type)) { // All subscribers
            return 'RANGE';
        }

        if (broadcast.type == 1) { // new subscribers
            return 'PAST HOURS, NEW SUBS';
        }

        if (broadcast.type == 7) { // new subscribers
            return 'USER LISTS';
        }
    };

    const renderTypeData = (broadcast) => {
        if ([0, 5].includes(broadcast.type)) {
            return broadcast.type_data
                ? `${broadcast.type_data.range_id_from} - ${broadcast.type_data.range_id_to}`
                : '';
        }

        if (broadcast.type == 1) { // new subscribers
            return `Past ${broadcast.type_data.new_subs_pastHours} hours, ${broadcast.type_data.new_subs_limit} subs, range ${broadcast.type_data.range_id_from} - ${broadcast.type_data.range_id_to}`;
        }

        if (broadcast.type == 2) { // Range
            const from = moment(broadcast.type_data.range_date_from);
            const to = moment(broadcast.type_data.range_date_to);

            let range = '';

            // same month and year
            if (from.format('MMMM') == to.format('MMMM') && from.format('YYYY') == to.format('YYYY')) {
                range = `${from.format('D')} - ${to.format('D MMM YYYY')}`;
            }

            if (from.format('MM') != to.format('MM') && from.format('YYYY') == to.format('YYYY')) {
                range = `${from.format('D MMM')} - ${to.format('D MMM YYYY')}`;
            }

            if (from.format('YYYY') != to.format('YYYY')) {
                range = `${from.format('D MMM YYYY')} - ${to.format('D MMM YYYY')}`;
            }

            range += `<br />${broadcast.type_data.range_id_from} - ${broadcast.type_data.range_id_to}`;

            return range;
        }

        if (broadcast.type == 7) { // user lists
            return broadcast.type_data && broadcast.type_data.userlist_names
                ? broadcast.type_data.userlist_names.join(', ')
                : null;
        }
    };

    const loadMoreStats = () => {
        loadStatsList();
    };

    const fetchBroadcastMedia = (b_id) => {
        const formData = new FormData();
        formData.append('b_id', b_id);

        axios({
            method: 'post',
            url: '/api/fetch-broadcast-media',
            data: formData
        })
            .then((data) => {
                setStatsListMedia(data.data.b_medias);
                setStatsListMediaModalIsOpen(true);
            })
            .catch((error) => {
                captureException(error);
            });
    };

    const handleStatsListMediaModal = () => {
        setStatsListMediaModalIsOpen(false);
    };

    const setExpandBroadcastsHandle = (b_id) => {
        setExpandBroadcasts([...expandBroadcasts, b_id]);
    };

    const setExpandBroadcastsRemoveHandle = (b_id) => {
        let filteredArray = expandBroadcasts.filter(item => item !== b_id);
        setExpandBroadcasts(filteredArray);
    };

    const handleCopy = (caption) => {
        copy(caption, {
            debug: false,
            message: 'Click to copy caption'
        });

        addToast('Caption successfully copied', { appearance: 'success', autoDismiss: true });
    };

    const loadStatsList = () => {
        const formData = new FormData();

        setStatsListCount(statsList.length);
        formData.append('stats_loaded', statsList.length);
        setStatsListLoading(true);

        axios({
            method: 'post',
            url: '/api/msg-stats-list',
            data: formData,
        })
            .then((data) => {
                if (statsList.length == 0)
                    setStatsList([...data.data.stats_list]);
                else
                    setStatsList([...statsList, ...data.data.stats_list]);

                if (data.data.stats_list.length < 5) {
                    setStatsListReachedEnd(true);
                } else {

                }
                //setStatsListCount(data.data.stats_list.length);
                setStatsListCount(statsList.length);
                setStatsListLoading(false);

                //setShowLoader(false);
            })
            .catch((error) => {
                captureException(error);
                setStatsListLoading(false);
            });
    };

    const handleCloseModal = () => {
        setStatsListModalIsOpen(false);
        setStatsList([]);
    };

    const handleOpenModal = () => {
        setStatsListModalIsOpen(true);
        loadStatsList();
    };

    const removeBroadcastMessage = () => {
        setRemovedBroadcasts([...removedBroadcasts, activeBroadcastId]);

        axios.delete(`/api/messages/all/${activeBroadcastId}`, {
            data: {
                source: 'broadcast',
                broadcast_id: activeBroadcastId
            }
        })
            .then((response) => {
                setActiveBroadcastId('');
                addToast('Unpaid messages for this broadcast removed.', { appearance: 'success', autoDismiss: true });
            })
            .catch((error) => {
                console.error({ error });
                setActiveBroadcastId('');
            });
    };

    const [showInfo, setShowInfo] = useState(false);
    const showStatsInfoModal = () => {
        setShowInfo(true);
    };

    const handleHideInfo = () => {
        setShowInfo(false);
    };


    return <><div className="stats-list-icon" onClick={handleOpenModal}><i className="fa-regular fa-chart-line-up" /></div>
        {statsListModalIsOpen && <ModalBootstrap
            show={statsListModalIsOpen}
            onHide={handleCloseModal}
            className="blockuser-modal"
            centered
            size="md"
        >
            <ModalBootstrap.Header>
                <ModalBootstrap.Title>MASS MESSAGE STATISTICS</ModalBootstrap.Title>
                <CloseButton
                    className="close"
                    onClick={handleCloseModal}
                    style={{ position: 'absolute', top: '32px', right: '12px' }}
                />
            </ModalBootstrap.Header>
            <ModalBootstrap.Body>

                <div className="stats-list-cont">
                    {
                        (statsListLoading && !statsListReachedEnd && statsList.length === 0)
                            ?
                            <div className="preloading-contianer"> <Spinner size="lg" animation="border" variant="primary" /></div>
                            :
                            statsList && statsList.map((k, index) => (
                                <div className={"stats-item " + (removedBroadcasts.find(element => element == k.id) ? ' stats-item-hide ' : '')} key={index}>
                                    <div className="stats-item-row">
                                        <div className="stats-item-lbl">
                                            DATE & TIME
                                        </div>
                                        <div className="stats-item-value">
                                            {
                                                moment.utc(k.created_at).local().format('LLL')
                                            }
                                        </div>
                                    </div>
                                    <div className="stats-item-row">
                                        <div className="stats-item-lbl">
                                            MESSAGE TYPE
                                        </div>
                                        <div className="stats-item-value">
                                            {
                                                renderTypeLabel(k)
                                            }
                                        </div>
                                    </div>
                                    {
                                        renderTypeDataLabel(k) && <div className="stats-item-row">
                                            <div className="stats-item-lbl">
                                                {
                                                    renderTypeDataLabel(k)
                                                }
                                            </div>
                                            <div className="stats-item-value">
                                                {/* {
                                                    renderTypeData(k)
                                                } */}
                                                <span dangerouslySetInnerHTML={{ __html: renderTypeData(k) }} />
                                            </div>
                                        </div>
                                    }
                                    {k.caption && k.caption.length > 0 && <div className="stats-item-row">
                                        <div className="stats-item-lbl stats-item-lbl-caption">
                                            CAPTION <span style={{ fontSize: '12px', color: '#0097fe', cursor: 'pointer' }} onClick={() => handleCopy(k.caption)} title="Click to copy caption"><i className="fa-sharp fa-regular fa-copy"></i></span>
                                        </div>
                                        <div className={"stats-item-value stats-item-value-caption " + (k.caption.length <= 45 ? ' single-line-caption ' : '') + (expandBroadcasts.find(element => element == k.id) ? ' stats-expanded ' : '')}>
                                            <span className="stats-default-value">{k.caption ? k.caption.substring(0, 90) : ''}
                                                <span className="read-more-cont" style={{ cursor: 'pointer' }} onClick={() => { setExpandBroadcastsHandle(k.id); }}>{k.caption && k.caption.length > 90 ? '... Read more' : ''}</span></span>
                                            <div className="stats-expanded-value">
                                                <div className="msg_header" dangerouslySetInnerHTML={{ __html: bannedWords(k.caption) || '' }}></div>
                                                <span className="read-less-cont" style={{ cursor: 'pointer' }} onClick={() => { setExpandBroadcastsRemoveHandle(k.id); }}>Read Less</span></div>
                                        </div>
                                    </div>}
                                    {k.img_count > 0 || k.vid_count > 0 ? <div className="stats-item-row">
                                        <div className="stats-item-lbl">
                                            # MEDIA
                                        </div>
                                        <div className="stats-item-value stats-item-value-media" onClick={() => { fetchBroadcastMedia(k.id); }}>
                                            {k.img_count > 0 && <span style={{ color: '#0097fe' }}><img src="https://privaposts.com/img-icon-dark.png?v=2" alt="image" /> <b>{k.img_count}</b></span>} {k.vid_count > 0 && <span style={{ color: '#0097fe' }}><img src="https://privaposts.com/vid-icon-dark.png?v=2" alt="video" className="stats-vid-icon" /> <b>{k.vid_count}</b></span>}
                                        </div>
                                    </div>
                                        : ''
                                    }
                                    <div className="stats-item-row">
                                        <div className="stats-item-lbl">
                                            PRICE
                                        </div>
                                        <div className="stats-item-value">
                                            {
                                                k.price > 0 ? currency(k.price).format({ precision: 2 }) : '$'
                                            }
                                        </div>
                                    </div>
                                    <div className="stats-item-row">
                                        <div className="stats-item-lbl">
                                            SENT
                                        </div>
                                        <div className="stats-item-value">
                                            {k.sent_num}
                                        </div>
                                    </div>
                                    <div className="stats-item-row">
                                        <div className="stats-item-lbl">
                                            VIEWED
                                        </div>
                                        <div className="stats-item-value">
                                            {k.read_num}
                                        </div>
                                    </div>
                                    <div className="stats-item-row">
                                        <div className="stats-item-lbl">
                                            PURCHASED
                                        </div>
                                        <div className="stats-item-value">
                                            {k.paid_num}
                                        </div>
                                    </div>
                                    <div className="stats-item-row stats-item-row-delete">
                                        <div className="stats-item-lbl">
                                            REMOVE UNPAID MESSAGES <i className="far fa-info-circle" style={{ color: '#0097fe', fontWeight: '500', cursor: 'pointer' }} onClick={showStatsInfoModal}></i>
                                        </div>
                                        <div className="stats-item-value stats-item-value-remove-msg">
                                            <span
                                                className="remove-mass-message"
                                                style={{ color: '#0097fe', fontWeight: 'bolder', textDecoration: 'none' }}
                                                onClick={() => handleConfirm(k.id)}
                                            >Remove</span>
                                        </div>
                                    </div>
                                </div>
                            ))
                    }

                </div>

                <div className="stats-list-load-more">
                    {
                        (!statsListLoading && !statsListReachedEnd) &&
                        <span className="stats-load-more-btn" onClick={() => { loadMoreStats(); }}>Load More</span>
                    }
                </div>

            </ModalBootstrap.Body>
        </ModalBootstrap>}


        {statsListMediaModalIsOpen && <ModalBootstrap
            show={statsListMediaModalIsOpen}
            onHide={handleStatsListMediaModal}
            className="blockuser-modal"
            centered
            size="md"
        >
            <ModalBootstrap.Header>
                <CloseButton
                    className="close"
                    onClick={handleStatsListMediaModal}
                    style={{ position: 'absolute', top: '32px', right: '12px' }}
                />
                <ModalBootstrap.Title>Media Attachments</ModalBootstrap.Title>
            </ModalBootstrap.Header>
            <ModalBootstrap.Body>
                <div className="media-attachment-container stash-cont">
                    {
                        statsListMedia && statsListMedia.map((k, index) => (
                            <div className="stash-item" key={index}>
                                <div
                                    className="stash-item-img"
                                    href="#"
                                    style={{ backgroundImage: `url('${s3Link}/${k.thumb_path}')` }}
                                ></div>
                                {/* {k.type.toLowerCase() == 'image' && <div className="stash-zoom-icon"><FontAwesomeIcon icon={['fas', 'magnifying-glass']} /></div>} */}
                            </div>
                        ))
                    }
                </div>
            </ModalBootstrap.Body>
        </ModalBootstrap>}

        {showConfirm && <AlertConfirmModal
            modalBody={`Remove for all subscribers (Paid PPVs are not removed)?`}
            show={showConfirm}
            setShow={setShowConfirm}
            useFunction={removeBroadcastMessage}
            isConfirm
        />}

        {showInfo && <ModalBootstrap
            show={showInfo}
            onHide={handleHideInfo}
            className="stats-info-modal"
            centered
            size="md"
            style={{ zIndex: 2147488 }}
        >
            <ModalBootstrap.Title style={{ minHeight: 'unset', padding: '12px' }}>
                <CloseButton className="close" onClick={handleHideInfo} style={{ position: 'absolute', top: '12px', right: '12px' }} />
                Remove for all subscribers (Paid PPVs are not removed)
            </ModalBootstrap.Title>
        </ModalBootstrap>}

    </>;
}
